module.exports = __webpack_public_path__ + "static/media/YF67_2.f35efa9a.jpg";